export const required = {
  required: true,
  message: 'Campo obligatorio',
};

export const espacioBlanco = {
  message: 'Este campo no puede tener espacios en blanco',
  validator: (_, value) => {
    const regex = /^[^\s]+(\s+[^\s]+)*$/;

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};

export const validarEmail = {
  message: 'Formato de email inválido',
  validator: (_, value) => {
    // Expresión regular mejorada para validar emails
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};

export const validarNumero = {
  message: 'Este campo solo acepta números',
  validator: (_, value) => {
    const regex = /^[0-9]+$/;

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};

export const rango = (min, max) => ({
  message: `Este campo solo acepta entre ${min} y ${max} caracteres alfanuméricos`,
  validator: (_, value) => {
    const regex = new RegExp(`^[a-zA-Z0-9\\s]{${min},${max}}$`);
    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
});

export const validarURL = {
  message: 'Formato de URL inválido',
  validator: (_, value) => {
    const regex = /^(ftp|http|https):\/\/[^ "]+$/;

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};

export const otpValidator = (max) => ({
  message: 'Por favor ingrese su código',
  validator: (_, value) => {
    if (!value || value.length < max) {
      return Promise.reject();
    }
    return Promise.resolve();
  },
});

export const formatCuit = (value) => {
  const cuit = value.replace(/\D/g, '');
  if (cuit.length <= 2) return cuit;
  if (cuit.length <= 10) return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}`;
  return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10, 11)}`;
};

export const maxCaracteres = () => ({
  message: `Este campo solo acepta hasta 5 caracteres`,
  validator: (_, value) => {
    if (!value || value.length <= 5) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
});

export const validarCuit = {
  message: 'CUIT inválido para persona jurídica',
  validator: (_, value) => {
    const cuit = value.replace(/\D/g, '');
    if (cuit.length !== 11) return Promise.reject();

    const prefijo = cuit.slice(0, 2);
    if (!['30', '33', '34'].includes(prefijo)) {
      return Promise.reject();
    }

    const cuitArray = cuit.split('').map(Number);
    const validador = cuitArray.pop();
    const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

    const suma = cuitArray.reduce((acc, num, i) => acc + num * pesos[i], 0);
    const mod = 11 - (suma % 11);
    const verificador = mod === 11 ? 0 : mod === 10 ? 9 : mod;

    return verificador === validador ? Promise.resolve() : Promise.reject();
  },
};


export const validateDNI = {
  message: 'DNI inválido',
  validator: (_, value) => {
    const str = (value ?? '').toString();
    const dni = str.replace(/\D/g, ''); 
    if (!dni) return Promise.reject();
    return /^\d{7,8}$/.test(dni) ? Promise.resolve() : Promise.reject();
  },
};

export const validarTelefonoAR = {
  message: 'Número inválido. Ingrese el código de área (sin 0) y el número (sin 15). Ej: 1123456789',
  validator: (_, value) => {
    if (!value) return Promise.reject();

    const cleaned = value.replace(/\D/g, '');

    // Validar largo (10 u 11 dígitos)
    if (cleaned.length < 10 || cleaned.length > 11) {
      return Promise.reject();
    }

    // Rechazar si empieza con 0
    if (cleaned.startsWith('0')) {
      return Promise.reject('No incluya el 0 en el código de área.');
    }

    // Rechazar si incluye el 15 después del código de área
    const posibles15 = cleaned.slice(0, 2); // posición típica si usan 15
    if (cleaned.includes('15') && posibles15 === '15') {
      return Promise.reject('No incluya el prefijo 15 en el número.');
    }

    return Promise.resolve();
  },
};


  export const handleCuitInput = (e) => {
    const input = e.target ;
    const formattedCuit = formatCuit(input.value);
    input.value = formattedCuit;
  };